import { takeEvery, call } from 'redux-saga/effects';

import { ACTIVE_VENUE_CHANGED } from 'features/App/App.saga';
import { makePath } from 'helpers/link-generation';

export function* handleActiveVenueChange(client, action) {
  const { venueId } = action;
  const newPath = makePath.items(venueId);

  yield call(client.navigate, newPath);
}

export function* watchActions(dependencies) {
  yield takeEvery(ACTIVE_VENUE_CHANGED, handleActiveVenueChange, dependencies);
}
